import React from 'react';
import ReactGA from 'react-ga';

import { CALLBACK_URLS, REFRESH_TOKEN_SAMPLE_OUTPUT, GET_USER_DETAILS_API_CURL_SAMPLE, GET_ACCESS_TOKEN_API_CURL_SAMPLE, GET_ACCESS_TOKEN_SAMPLE_OUTPUT, REVOKE_TOKEN_USING_ACCESS_TOKEN_POST_REQUEST,
    REVOKE_TOKEN_USING_ACCESS_TOKEN_SAMPLE_OUTPUT, REVOKE_TOKEN_USING_REFRESH_TOKEN_POST_REQUEST, REVOKE_TOKEN_USING_REFRESH_TOKEN_SAMPLE_OUTPUT } from './AuthenticationConstants';
import CodeComponent from '../../../core/CodeComponent/CodeComponent';
import { PanelGroup, Image, Table } from 'react-bootstrap';
import PanelComponent from '../../../core/PanelComponent/PanelComponent';

import './authenticationComponent.scss';
import '../../../core/GridComponent/grid.scss';
import '../../../core/CodeComponent/code.scss';
// import GridComponent from '../../../core/GridComponent/GridComponent';

class AuthenticationComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeKey: 1,
        }
    }

    handleSelect = (activeKey) => {
        this.setState({ activeKey })
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Authentication Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { activeKey } = this.state;
        return <div className="authentication-component">
            <div>
                <h2>Accessing existing Life Fitness account users data using OAuth2</h2>
            </div>
            <br />
            <div className="section">
                <p>Partner API uses OAuth2 as authentication protocol in accessing the
                    Life Fitness account-specific services. All the services require following the OAuth2 protocol.</p>
                <p>The services require an <b>Access Token</b> to access the Web Services. To get an Access Token,
                    the following flow is required to be followed:</p>
            </div>
            <p><b>To summarize, the following are the necessary steps to access OAuth2-secured services (each step
                is explained in detail):</b></p>

            <div className="row">
                <figure>
                    <Image src={require('./accesss_token_flow.png')} />
                </figure>
            </div>

            <div>
                <PanelGroup accordion id="pub-panel" activeKey={activeKey} onSelect={this.handleSelect}>
                    <PanelComponent
                        title="1. Developer Application calls the Authorization Endpoint"
                        eventKey={1}
                        activeKey={activeKey}
                    >
                        <div>
                            <p>The <b>Developer Application</b> accesses the <b>Authorization Endpoint</b>,
                                passing the Client ID and Redirection URI.</p>
                            <br />
                            <h4>SANDBOX URL</h4>

                            <CodeComponent type="url" code={CALLBACK_URLS.sandbox_oauthEndpoint} />
                            <br />

                            <h4>PRODUCTION URL</h4>

                            <CodeComponent type="url" code={CALLBACK_URLS.production_oauthEndpoint} />
                            <br />

                            <h4>Query Parameters</h4>
                            <div className="grid-wrapper" align="left">
                                <Table hover className="grid">
                                    <thead>
                                        <tr>
                                            <th>
                                                Parameter Name
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td align="left">
                                                response_type
                                            </td>
                                            <td align="left">
                                                Type of response the server is expecting. Supported value: "code"
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="left">
                                                client_id
                                            </td>
                                            <td align="left">
                                                Valid OAuth ClientID
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="left">
                                                redirect_uri
                                            </td>
                                            <td align="left">
                                                Redirection URI to be used by Life Fitness server to provide Authorization Code.
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                            <br />
                            <h4>Sample Call</h4>
                            <div className='code http'>
                                <pre>
                                    <span>GET</span>
                                    <br />
                                    <span>{CALLBACK_URLS.sandbox_oauthEndpoint}?</span>
                                    <br />
                                    <span>response_type=code</span>
                                    <br />
                                    <span>client_id=wwjk121jhkj231</span>
                                    <br />
                                    <span>redirect_uri=https%3A%2F%2F...</span>
                                </pre>
                            </div>
                        </div>
                    </PanelComponent>
                    <PanelComponent
                        title="2. Exerciser is asked to authenticate and authorize"
                        eventKey={2}
                        activeKey={activeKey}
                    >
                        <div>
                            <p><b>Partner API Website</b> serves the <b>Authorization Endpoint</b>,
                                requesting the exerciser to verify by logging in. The user authorizes to provide the
                                Developer App access to the user's data. A screen with Username / Password is to be shown.</p>
                            <p>After a successful login, Partner API Website redirects the screen to
                                the <b>Redirection URL</b> provided, passing the Authorization Code.</p>
                            <br />
                            <h4>Sample Screen</h4>
                            <Image src={require('./authorization_login.png')} />
                            <p>The Redirection URI receives the code.</p>
                            <br />
                            <h4>Sample Output</h4>
                            <div className='code http'>
                                <pre>
                                    <span>https://redirect uri</span>
                                    <br />
                                    <span>?code=f4lbd32556eb1391745ad8ccd25f|765304</span>
                                </pre>
                            </div>
                            <p>If the login credentials provided are invalid the login screen shows related errors.</p>
                            <br />
                            <h4>Sample Screen</h4>
                            <Image src={require('./authorization_login_error.png')} />
                            <p>If the login is cancelled then user is redirected to the third party provided Redirection
                                URL with parameters error as access denied and additional error description.</p>
                            <br />
                            <h4>Sample Output</h4>
                            <div className='code http'>
                                <pre>
                                    <span>https://redirect uri</span>
                                    <br />
                                    <span>?error=access_denied&error_description=The+user+has+not+authorized+for+this+application.</span>
                                </pre>
                            </div>
                            <br />
                        </div>
                    </PanelComponent>
                    <PanelComponent
                        title="3. Developer exchanges code for access token"
                        eventKey={3}
                        activeKey={activeKey}
                    >
                        <div>
                            <p><b>Developer Application</b> makes an API request to retrieve the user access Token
                                by calling the <b>Token Endpoint</b>, passing the Authorization Code retrieved in previous step.</p>
                            <br />
                            <h4>SANDBOX URL</h4>

                            <CodeComponent type="url" code={CALLBACK_URLS.sandbox_tokenEndpoint} />
                            <br />

                            <h4>PRODUCTION URL</h4>

                            <CodeComponent type="url" code={CALLBACK_URLS.production_tokenEndpoint} />
                            <br />
                            <h4>Body Parameters</h4>
                            <div className="grid-wrapper token-parameters">
                                <Table hover className="grid">
                                    <thead>
                                        <tr>
                                            <th>
                                                Parameter Name
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                            <th>
                                                &nbsp;
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td align="left">
                                                code
                                            </td>
                                            <td align="left">
                                                Authorization code received in the previous step.
                                            </td>
                                            <td align="left">
                                                <b>mandatory</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                            <h4>Headers</h4>
                            <div className="grid-wrapper token-parameters">
                                <Table hover className="grid">
                                    <thead>
                                        <tr>
                                            <th>
                                                Header Name
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                            <th>
                                                &nbsp;
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td align="left">
                                                Authorization
                                            </td>
                                            <td align="left">
                                               Bearer {'{'}oauth-access-token{'}'} retrieved using Authentication API which requires the Client ID and Client Secret.
                                            </td>
                                            <td align="left">
                                                <b>mandatory</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                            <br />
                            <h4>Sample Call with Redirect URL</h4>
                            <CodeComponent type="http" code={GET_ACCESS_TOKEN_API_CURL_SAMPLE} />
                            <br />
                            <p>Returns a json response with access token, refresh token and the expiry date</p>
                            <CodeComponent type="http" code={GET_ACCESS_TOKEN_SAMPLE_OUTPUT} />
                            <br />
                        </div>
                    </PanelComponent>
                    <PanelComponent
                        title="4. Accessing APIs using user access token"
                        eventKey={4}
                        activeKey={activeKey}
                    >
                        <div>
                            <p>Developer Application can now access the User related Partner API services by passing the user-access-token header in every request.</p>
                            <br />
                            <h4>Sample API cURL</h4>
                            <CodeComponent type="http" code={GET_USER_DETAILS_API_CURL_SAMPLE} />
                        </div>
                    </PanelComponent>
                    <PanelComponent
                        title="5. Requesting a new Token after User Access Token expires"
                        eventKey={5}
                        activeKey={activeKey}
                    >
                        <div>
                            <p>The Partner API Website validates if the access token is expired on every service
                                call; if so, the service will then return an error indicating that the token is expired. The
                                <b> Developer Application</b> can call the <b>Refresh Token Endpoint</b> passing the refresh
                                token provided in (3). Partner APIs validates the Refresh Token and
                                responds with a newly issued Access Token and Refresh Token.</p>
                            <br />
                            <div className='code http'>
                                <pre>
                                    <span>POST</span>
                                    <br />
                                    <span>curl --location '{CALLBACK_URLS.sandbox_refreshToken}' \
                                        <br />--header 'Accept: application/json' \
                                        <br />--header 'Authorization: Bearer eyAbc...' \
                                        <br />--header 'user-access-token: xyz123...'
                                    </span>
                                </pre>
                            </div>
                            <p>Return a json response with access token, refresh token and the expiry date</p>
                            <br />
                            <h4>Sample Output</h4>
                            <CodeComponent type="http" code={REFRESH_TOKEN_SAMPLE_OUTPUT} />
                        </div>
                    </PanelComponent>
                    <PanelComponent
                        title="6. Revoking OAccess Tokens and Refresh Tokens"
                        eventKey={6}
                        activeKey={activeKey}
                    >
                        <div>
                            <p>Revocation endpoint invalidates access and refresh tokens upon client request. The
                                Developer Application can call POST call to the Token revokation API (/revoke-token) passing either an access token (the short-lived session token issued by Life Fitness Partner APIs)
                                or a refresh token (the long-lived persistent token). Revoking an
                                access token is analogous to simply logging out, but revoking a refresh token terminates
                                an app's authorization to call APIs on behalf of the user and revokes all outstanding
                                access tokens issued against that refresh token. After revoking an access token, the <b>Developer
                                Application</b> can later retrieve a new access token using refresh token (/refresh-token).
                                However, when revoking the refresh token, the Developer Application has to start the OAuth flow from the beginning in-order to obtain a new
                                access token.</p>
                            <br />
                            <h4>SANDBOX URL</h4>
                            <CodeComponent type="url" code={CALLBACK_URLS.sandbox_revokeToken} />
                            <br />
                            <h4>PRODUCTION URL</h4>
                            <CodeComponent type="url" code={CALLBACK_URLS.production_revokeToken} />
                            <br />
                            <h4>Sample API Request (Revoke using Access Token)</h4>
                            <p>Revoke an access token by making a POST request to the revocation endpoint with the access token you wish to revoke.</p>
                            <CodeComponent type="http" code={REVOKE_TOKEN_USING_ACCESS_TOKEN_POST_REQUEST} />
                            <h4>Sample Output</h4>
                            <CodeComponent type="http" code={REVOKE_TOKEN_USING_ACCESS_TOKEN_SAMPLE_OUTPUT} />
                            <h4>Sample API Request (Revoke using Refresh Token)</h4>
                            <p>Revoke a refresh token by making a POST request to the revocation endpoint with the refresh token you wish to revoke.</p>
                            <CodeComponent type="http" code={REVOKE_TOKEN_USING_REFRESH_TOKEN_POST_REQUEST} />
                            <h4>Sample Output</h4>
                            <CodeComponent type="http" code={REVOKE_TOKEN_USING_REFRESH_TOKEN_SAMPLE_OUTPUT} />
                        </div>
                    </PanelComponent>
                </PanelGroup>
            </div>
        </div>
    }
}

export default AuthenticationComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Authentication/AuthenticationComponent.js